import React, { FC, useState } from 'react';
import { View } from 'react-native';
import { ChangeMap, TWCPage } from '@components';
import { useRecoilState } from 'recoil';

import { mapPageTestIDs } from '@constants';
import { navigationService } from '@services';
import { mapTypeState } from '@store';
import { Route } from '@types';

import { PAGE_CHILD_IDS } from './constants';
import { styles } from './styles';

type ChangeMapModalPageProps = {
  route: Route;
};

export const ChangeMapModalPage: FC<ChangeMapModalPageProps> = ({ route }) => {
  const [mapType, setMapType] = useRecoilState(mapTypeState);
  const { useDefaultLocation } = route.params ?? {};

  const [tileToFocus, setTileToFocus] = useState(null);

  const onNewMapSelected = (newOverlayType: string, newZoomPreset: string) => {
    if (newOverlayType !== mapType.overlay || newZoomPreset !== mapType.zoom) {
      setMapType({ overlay: newOverlayType, zoom: newZoomPreset });
    }

    navigationService.navigate(mapPageTestIDs.mapPage, { useDefaultLocation });
  };

  return (
    <TWCPage
      childIds={PAGE_CHILD_IDS}
      firstFocus={mapPageTestIDs.changeMapOverlayTypeRadarButton}
      hasBackground={false}
      isMenuItem={false}
      pageID={mapPageTestIDs.changeMapPage}
    >
      <View style={styles.modalContent}>
        <ChangeMap
          selectedOverlayType={mapType.overlay}
          selectedZoom={mapType.zoom}
          setTileToFocus={setTileToFocus}
          tileToFocus={tileToFocus}
          onNewMapSelected={onNewMapSelected}
        />
      </View>
    </TWCPage>
  );
};
